import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Reminder } from './../../../model/reminder.model';
import {NgbDateStruct, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { DateformatService } from '../../../../util/dateformat.service';
import moment from 'moment';
import { isNumber } from '@app/trackvision/util/util';

@Component({
    selector: 'app-reminder',
    templateUrl: './reminder.component.html',
    styleUrls: ['./reminder.component.scss'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: DateformatService }
    ],
    standalone: false
})
export class ReminderComponent implements OnInit {
	@Input() subject: string;
	@Input() date: string;
	@Input() time: string;
	@Output() sendReminder = new EventEmitter<any>();
	// Inputs for editing reminder
	@Input() date_start: string;
	@Input() date_end: string;
	@Input() ordinal_day: number;
	@Input() ordinal_month: number;
	@Input() type_reminder: number;
	@Input() days_of_week: any;

	loading: boolean = false;
	listDays: boolean = true;
	listMonth: boolean = false;
	newReminder: Reminder = new Reminder();
	numbRepeating: number = 1;
	numbRepeatingAfter: number = 1;
	minvalue: number = 1;
	maxvalue: number = 999;
	finishAction: string = 'nunca';
	errorMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
	model1: NgbDateStruct = null;
	model2: NgbDateStruct = null;
	monthChosenDay: string = '';
	monthChosenOrdinal: string = '';
	mindate = undefined;
	mindateStart = undefined;
	selectedDay: string;
	successMessage = '';
	numbOcurrence: number;
	calendars1: Array<string> = ['Semanalmente', 'Mensualmente'];
	ordinals: Array<string> = ['primer', 'segundo', 'tercer', 'cuarto', 'último'];
	days: Array<string> = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
	selectedItemsList = [];
  checkedIDs = [];
	checkboxesDataList = [
    {
      id: '1',
      label: 'lu.',
      isChecked: false
    },
    {
      id: '2',
      label: 'ma.',
      isChecked: false
    },
    {
      id: '3',
      label: 'mi.',
      isChecked: false
    },
    {
      id: '4',
      label: 'ju.',
      isChecked: false
    },
    {
      id: '5',
      label: 'vi.',
      isChecked: false
    },
    {
      id: '6',
      label: 'sá.',
      isChecked: false
    },
    {
      id: '0',
      label: 'do.',
      isChecked: false
    },
	];
	typeReminder: number = 2;
	ordinalMonth: number;
	ordinalDay: number;
	typeCalendar: string = 'Semanalmente';
	ordinal_name: string = '';
	ordinal_day_name: string = '';
  constructor(
		public activeModal: NgbActiveModal,
	) { }

  ngOnInit() {
		this.fetchSelectedItems();
		this.fetchCheckedIDs();
		this.messagesSubmitForm();
		if (this.date){
			this.insertDates(this.date);
			this.changeDatetoName(this.date);
			this.selectedOrdinalDay(this.date);
		}
		this.changeSelection();
		// here insert data If exist date_start and date_end
		if (this.date_start && this.date_end && isNumber(this.type_reminder)){
			this.insertDates(this.date_start);
			this.insertDateEnd(this.date_end);
			this.typeReminderChosen(this.type_reminder);
		}
	}
	// Subimit Form
	submitReminder() {
		const resultValidation = 	this.validationWeekDate();
		if (resultValidation) {
			const startDate = this.model1.year + '-' + this.model1.month + '-' + this.model1.day;
			const endDate = this.model2.year + '-' + this.model2.month + '-' + this.model2.day;
			if (this.typeReminder === 2 ) {
				let idWeek = [];
				// tslint:disable-next-line: forin
				for (let sil in this.selectedItemsList){
					idWeek.push(Number(this.selectedItemsList[sil].id));
				}
				this.newReminder.type_reminder = this.typeReminder;
				this.newReminder.date_start = startDate;
				this.newReminder.date_end = endDate;
				this.newReminder.days_of_week = idWeek;
				this.newReminder.ordinal_day = null;
				this.newReminder.ordinal_month = null;
				this.newReminder.active = true;
				this.sendingReminder(this.newReminder);
				idWeek = [];
			} else if ( this.typeReminder === 3) {
				this.newReminder.type_reminder = this.typeReminder;
				this.newReminder.date_start = startDate;
				this.newReminder.date_end = endDate;
				this.newReminder.ordinal_day = this.ordinalDay;
				this.newReminder.ordinal_month = this.ordinalMonth;
				this.newReminder.days_of_week = null;
				this.newReminder.active = true;
				this.sendingReminder(this.newReminder);
			}
		}
	}

	sendingReminder(reminder){
		//let stringObj = reminder;
		this._success.next('Se ha registrado el recordatorio.');
		setTimeout(() => this.activeModal.dismiss(), 1500);
		setTimeout(() => this.sendReminder.emit(reminder), 1000);
		// clean the object
		this.newReminder = new Reminder();
	}
	onValueChangedAfter(value){
		this.numbRepeatingAfter = value;
	}
	onSelectOption1(typeR) {
		if ( typeR === 'Semanalmente') {
			this.typeReminder = 2;
			this.listDays = true;
			this.listMonth = false;
		} else if (typeR === 'Mensualmente') {
			this.typeReminder = 3;
			this.listMonth = true;
			this.listDays = false;
		} else {
			this.listDays = false;
			this.listMonth = false;
		}
	}
	// ordinal Month
	onSelectOption2(ordinal) {
		// 'primer', 'segundo', 'tercero', 'cuarto', 'último
		switch (ordinal) {
			case 'primer':
				this.ordinalMonth = 1;
				break;
			case 'segundo':
				this.ordinalMonth = 2;
				break;
			case 'tercer':
				this.ordinalMonth = 3;
				break;
			case 'cuarto':
				this.ordinalMonth = 4;
				break;
			case 'último':
				this.ordinalMonth = 5;
				break;
			default:
				break;
		}
	}
	// ordinal Day
	onSelectOption3(ordinalDay) {
		// 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'
		switch (ordinalDay) {
			case 'lunes':
				this.ordinalDay = 1;
				break;
			case 'martes':
				this.ordinalDay = 2;
				break;
			case 'miércoles':
				this.ordinalDay = 3;
				break;
			case 'jueves':
				this.ordinalDay = 4;
				break;
			case 'viernes':
				this.ordinalDay = 5;
				break;
			case 'sábado':
				this.ordinalDay = 6;
				break;
			case 'domingo':
				this.ordinalDay = 0;
				break;
			default:
				break;
		}
	}
	// SELECT DAYS
	changeSelection() {
    this.fetchSelectedItems();
  }

  fetchSelectedItems() {
    this.selectedItemsList = this.checkboxesDataList.filter((value, index) => {
      return value.isChecked;
		});
  }

  fetchCheckedIDs() {
    this.checkedIDs = [];
    this.checkboxesDataList.forEach((value, index) => {
      if (value.isChecked) {
        this.checkedIDs.push(value.id);
      }
    });
	}
	// Messages for submit
	messagesSubmitForm() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(1500)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(1500)
		).subscribe(() => this.errorMessage = '');
	}

	messagesError(msgError) {

		this._error.next(msgError);
	}
	// INSERT DATES TO THE CALENDAR
	insertDates(date: string) {
		const dateArray = date.split('/');
		this.model1 = {
			year: Number(dateArray[2]),
			month: Number(dateArray[1]),
			day: Number(dateArray[0])
		};
		this.mindateStart = this.model1;
		this.mindate = this.model1;
	}
	// insert End Date
	insertDateEnd(date: string) {
		const dateArray = date.split('/');
		this.model2 = {
			year: Number(dateArray[2]),
			month: Number(dateArray[1]),
			day: Number(dateArray[0])
		};
		//this.mindateStart = this.model1;
		//this.mindate = this.model1;
	}
	// select the day of the week
	changeDatetoName(date: string) {
		const dateArray = date.split('/');
		const dateString = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0] + 'T00:00:00';
		this.selectedDay = moment(dateString).format('d');
		for ( let chboxlist in this.checkboxesDataList) {
			if (this.checkboxesDataList[chboxlist].id  === this.selectedDay) {
				this.checkboxesDataList[chboxlist].isChecked = true;
				break;
			}
		}
	}
	// first day of the month
	selectedOrdinalDay(date:string) {
		// select month day by switch
		switch (this.selectedDay) {
			case '1':
				this.monthChosenDay = 'lunes';
				this.ordinalDay = 1;
				break;
			case '2':
				this.monthChosenDay = 'martes';
				this.ordinalDay = 2;
				break;
			case '3':
				this.monthChosenDay = 'miércoles';
				this.ordinalDay = 3;
				break;
			case '4':
				this.monthChosenDay = 'jueves';
				this.ordinalDay = 4;
				break;
			case '5':
				this.monthChosenDay = 'viernes';
				this.ordinalDay = 5;
				break;
			case '6':
				this.monthChosenDay = 'sábado';
				this.ordinalDay = 6;
				break;
			case '0':
				this.monthChosenDay = 'domingo';
				this.ordinalDay = 0;
				break;
			default:
				break;
		}
		// select month ordinal
		const dateArray = date.split('/');
		const dayDate = Number(dateArray[0]);
		// 'primero', 'segundo', 'tercero', 'cuarto', 'último'
		if (dayDate >= 1 && dayDate <= 7) {
			this.ordinalMonth = 1;
			this.monthChosenOrdinal = 'primer';
		} else if (dayDate >= 8 && dayDate <= 14) {
			this.ordinalMonth = 2;
			this.monthChosenOrdinal = 'segundo';
		} else if (dayDate >= 15 && dayDate <= 21) {
			this.ordinalMonth = 3;
			this.monthChosenOrdinal = 'tercer';
		} else if (dayDate >= 22 && dayDate <= 28) {
			this.ordinalMonth = 4;
			this.monthChosenOrdinal = 'cuarto';
		} else if (dayDate >= 29 && dayDate <= 31) {
			this.ordinalMonth = 5;
			this.monthChosenOrdinal = 'último';
		}
	}
	changeMinDate(value) {
		this.mindate = value;
	}
	// validation Form for week and end_date
	validationWeekDate(): boolean {
		if (this.selectedItemsList.length <= 0 && this.model2 === null ) {
			this._error.next('Error: Falta seleccionar un día y fecha fin.');
			return false;
		} else if (this.selectedItemsList.length <= 0 && this.model2 !== null ) {
			this._error.next('Error: Falta seleccionar un día de la semana.');
			return false;
		} else if (this.selectedItemsList.length > 0 && this.model2 === null ) {
			this._error.next('Error: Falta fecha fin.');
			return false;
		} else if (this.selectedItemsList.length > 0 && this.model2 !== null ) {
			return true;
		}
	}
	// this is for editing reminder process 
	typeReminderChosen(type_id: number){
		switch (type_id) {
			case 2:
				//this.onSelectOption1('Mensualmente'); this change the view to monthly
				//set the variables for the first moment 
				this.typeCalendar = 'Semanalmente';
				this.onSelectOption1(this.typeCalendar);
				if(isNumber(this.days_of_week)){
					let daysWeek = [];
					daysWeek.push(this.days_of_week)
					this.selectDaysArray(daysWeek);
				}else {
					this.selectDaysArray(this.days_of_week);
				}
				
				const dateArray = this.date_start.split('/');
				const dateString = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0] + 'T00:00:00';
				this.selectedDay = moment(dateString).format('d');
				this.selectedOrdinalDay(this.date_start);
				break;
			case 3:
				// initials variables nad open the selects 
				this.typeCalendar = 'Mensualmente';
				this.onSelectOption1(this.typeCalendar);
				// Here select both variable for selects just for view 
				this.getOrdinalMonth(this.ordinal_month);
				this.monthChosenOrdinal = this.ordinal_name;
				this.onSelectOption2(this.monthChosenOrdinal);
				this.ordinalMonthlyDays(this.ordinal_day);
				this.monthChosenDay = this.ordinal_day_name;
				this.onSelectOption3(this.monthChosenDay);
				// get value  into selectItemList 
				this.selectDayMonth(this.ordinal_day);
				//this.changeDatetoName(this.date_start);
				break;
			default:
				break;
		}
	}
	// in: number out: string 
	getOrdinalMonth(numb: number) {
		// 'primer', 'segundo', 'tercero', 'cuarto', 'último
		switch (numb) {
			case 1 :
				this.ordinal_name = 'primer';
				break;
			case 2 :
				this.ordinal_name = 'segundo';
				break;
			case 3 :
				this.ordinal_name = 'tercer';
				break;
			case 4 :
				this.ordinal_name = 'cuarto';
				break;
			case 5 :
				this.ordinal_name = 'último';
				break;
			default:
				break;
		}
	}
	ordinalMonthlyDays(day: number) {
		// 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'
		switch (day) {
			case 1 :
				this.ordinal_day_name = 'lunes';
				break;
			case 2 :
				this.ordinal_day_name = 'martes';
				break;
			case 3 :
				this.ordinal_day_name = 'miércoles';
				break;
			case 4 :
				this.ordinal_day_name = 'jueves';
				break;
			case 5 :
				this.ordinal_day_name = 'viernes';
				break;
			case 6 :
				this.ordinal_day_name = 'sábado';
				break;
			case 0 :
				this.ordinal_day_name = 'domingo';
				break;
			default:
				break;
		}
	}
	// select days array 
	selectDaysArray(days: Array<number>){
		// create the view for checking box
	  days.forEach(elDay => {
			this.checkboxesDataList.forEach(elCheck => {
				if(elDay == Number(elCheck.id)){
					elCheck.isChecked = true;
				}
			});
		});
		// all selects true, they are going to get into to selectItemList, then if the user 
		// does not fo any changes, this information is going to back end. 
		this.checkboxesDataList.forEach(el => {
			if ( el.isChecked == true ){
				this.selectedItemsList.push(el);
			}
		});

	}
	selectDayMonth(day: number){
		this.checkboxesDataList.forEach(elCheck => {
			if(day == Number(elCheck.id)){
				elCheck.isChecked = true;
			}
		});
		this.checkboxesDataList.forEach(el => {
			if ( el.isChecked == true ){
				this.selectedItemsList.push(el);
			}
		});
	}
}
